import script from "./Options.vue?vue&type=script&setup=true&lang=ts"
export * from "./Options.vue?vue&type=script&setup=true&lang=ts"

import "./Options.vue?vue&type=style&index=0&id=5e3c01b6&scoped=true&lang=scss"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3c01b6"]])

export default __exports__